"use client";
import { IBlocks, IBlogPost, IUserData } from "@/types";
import React from "react";
import CardSetting from "@/components/admin/settings/CardSetting";
import { cn } from "@/lib/utils";
import { Label } from "@/components/ui/label";
import moment from "moment";
import { Button } from "@/components/ui/button";
interface Props {
    account: IUserData;
    block: IBlocks;
    blockUpdate: React.Dispatch<React.SetStateAction<IBlocks>>;
    update: (value: IBlocks) => void;
    posts: IBlogPost[];
}

export default function BlogPostSingleOptions({
    account,
    block,
    blockUpdate,
    update,
    posts,
}: Props) {
    const select = (post_id: string) => {
        update({
            ...block,
            options: {
                ...block.options,
                post_id: post_id,
            },
        });
    };
    return (
        <CardSetting
            noBorder
            title={
                posts.length === 0
                    ? "No blog posts available"
                    : "Choose a blog post"
            }
        >
            <div className="flex w-full flex-col gap-3">
                <div className="relative flex w-full flex-col gap-4">
                    {posts.length === 0 ? (
                        <div className="">
                            <Label variant={"toggle"}>
                                Create a blog post to see it here
                            </Label>
                            <Label variant={"subtoggle"}>
                                You can create a blog post from the "Blog"
                                button on the sidebar
                            </Label>
                        </div>
                    ) : (
                        posts.map((post, index) => {
                            return (
                                <div
                                    key={index}
                                    onClick={() => select(post.id)}
                                    className={cn(
                                        "flex items-start gap-2 rounded-md border-2 p-2",
                                        post.id === block.options?.post_id
                                            ? "border-primary"
                                            : ""
                                    )}
                                >
                                    <div className="flex flex-col">
                                        <Label
                                            variant="toggle"
                                            className="text-lg"
                                        >
                                            {post.title}
                                        </Label>
                                        <Label variant={"subtoggle"}>
                                            Posted{" "}
                                            {moment(post.created_at).format(
                                                "Do MMM, YYYY"
                                            )}{" "}
                                            ({moment(post.created_at).fromNow()}
                                            )
                                        </Label>
                                        <Label variant={"subtoggle"}>
                                            {post.category_name}
                                        </Label>
                                    </div>
                                    <img
                                        className="ml-auto h-14 w-14 rounded-md object-cover"
                                        src={post.img}
                                        alt={post.title}
                                    ></img>
                                </div>
                            );
                        })
                    )}
                </div>
            </div>
        </CardSetting>
    );
}
